import { Controller } from "@hotwired/stimulus";
import JobProcessingChannel from "../channels/job_processing_channel";

export default class extends Controller {
  static targets = ["progressBar", "message", "toast", "spinner"];

  connect() {
    this.fileId = this.data.get("file-id");
    // Store subscription status
    this.isSubscribed = false;
  }

  subscribeToStatus() {
    // Only subscribe if not already subscribed
    if (this.isSubscribed) return;

    this.toastTarget.classList.remove("d-none");
    this.subscription = JobProcessingChannel.subscribe(this.fileId, {
      received: (data) => this.updateProgress(data),
      connected: () => {
        console.log("Channel connected");
        this.isSubscribed = true;
      },
      disconnected: () => {
        console.log("Channel disconnected");
        this.isSubscribed = false;
        this.subscription = null;
      },
    });
  }

  updateProgress(data) {
    this.progressBarTarget.style.width = `${data.progress}%`;

    // Remove the spinner when we receive the first update with a message
    if (data.message && this.hasSpinnerTarget) {
      this.spinnerTarget.remove();
    }

    this.messageTarget.textContent = data.message;

    if (data.progress === 100) {
      this.progressBarTarget.classList.add("bg-success");

      // Don't unsubscribe immediately, wait for timeout
      if (data.complete) {
        // Wait a short time to show success state before any page redirect happens
        setTimeout(() => {
          this.safeUnsubscribe();
          this.hideToast();
        }, 2000);
      }
    }
  }

  hideToast() {
    this.progressBarTarget.classList.remove("bg-success");
    this.messageTarget.textContent = "";
    this.progressBarTarget.style.width = "0%";
    this.toastTarget.classList.add("d-none");

    // Make sure we're unsubscribed when hiding the toast
    this.safeUnsubscribe();
  }

  safeUnsubscribe() {
    try {
      if (this.subscription && this.isSubscribed) {
        this.subscription.unsubscribe();
        this.isSubscribed = false;
        this.subscription = null;
      }
    } catch (error) {
      console.error("Error unsubscribing:", error);
      this.isSubscribed = false;
      this.subscription = null;
    }
  }

  disconnect() {
    // Always attempt to unsubscribe when the controller is disconnected
    this.safeUnsubscribe();
  }
}
